
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import ListBase from '@/lib/listbase';
    import Util from '@/lib/util';
    import VWidget from '@/components/VWidget.vue';
    import VueApexCharts from 'vue-apexcharts'

    @Component({
        components: { apexcharts: VueApexCharts, VWidget },
    })

    export default class TablesStats extends ListBase {
        options: any = {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                stackType: '100%'
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: 'Respuestas',
                align: 'center'
            },
            xaxis: {
                categories: ['Satisfaccion General', this.L('Atencion del Asesor'), 'Trabajos Realizados', 'NPS'],
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return "Respuesta  Numerica: " + val
                    }
                }
            },
            fill: {
                opacity: 1

            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40
            }
        };
        
        get series() {
            return this.$store.state.quiz.ranking;
        }

        get loading() {
            return this.$store.state.quiz.loading;
        }

        loadData() {
            this.$emit('load-data'); 
        }

        mounted() { 
        }
     }
